<template>
  <va-dropdown
    class="language-dropdown"
    offset="0, 16px"
    fixed
  >
    <va-icon slot="anchor" :name="['flag-icon flag-icon-large', flagIconClass(currentLanguage())]"/>
    <div class="language-dropdown__content pl-4 pr-4 pt-2 pb-2">
      <div class="language-dropdown__item row align--center pt-1 pb-1 mt-2 mb-2"
        v-for="(option, id) in options"
        :key="id"
        :class="{ active: option.code === currentLanguage() }"
        @click="setLanguage(option.code)"
      >
        <va-icon :name="['flag-icon flag-icon-small', flagIconClass(option.code.toLowerCase())]"/>
        <span class="dropdown-item__text">
          {{ option.name }}
        </span>
      </div>
    </div>
  </va-dropdown>
</template>

<script>
import Vue from 'vue'
import store from '@/store'

export default {
  name: 'language-dropdown',
  props: {
    options: {
      type: Array,
      default: () => [
        {
          code: 'GB',
          name: 'English',
        },
        {
          code: 'GR',
          name: 'Ελληνικά',
        },
      ],
    },
  },
  methods: {
    async setLanguage (locale) {
      await store.dispatch('getAppTranslations', locale)
      Vue.i18n.add(locale, store.getters.appTranslations.translation)
      Vue.i18n.set(locale)
      localStorage.setItem('appLanguage', locale)
    },

    currentLanguage () {
      return Vue.i18n.locale() === 'GB' ? 'gb' : Vue.i18n.locale().toLowerCase()
    },

    flagIconClass (code) {
      return `flag-icon-${code}`
    },
  },
}
</script>

<style lang="scss">
@import "~flag-icon-css/css/flag-icon.css";

.language-dropdown {
  cursor: pointer;

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: 0.5rem;
    width: 12rem;

    .flag-icon-small {
      min-width: 1.5rem;
      min-height: 1.5rem;
      margin-right: 0.5rem;
    }
  }

  &__item {
    padding-bottom: 0.625rem;
    cursor: pointer;
    flex-wrap: nowrap;
    color: $vue-darkest-blue;

    &:last-of-type {
      padding-bottom: 0 !important;
    }

    &:hover,
    &.active {
      color: $vue-green;
    }
  }

  @media screen and (max-width: 767px) {
    position: relative;
    right: 75px;
  }

  .flag-icon::before {
    content: "";
  }

  .flag-icon-large {
    display: block;
    width: 31px;
    height: 23px;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}

.auth-layout .language-dropdown {
  @media screen and (max-width: 767px) {
    right: 0;
  }
}

.auth-layout .language-dropdown .flag-icon-large {
  width: 24px;
  height: 18px;
}
</style>
